export enum AccessTypes {
    view = 'view',
    edit = 'edit',
    execute = 'execute',
    delete = 'delete',
    add = 'add',
    detail = 'detail'
}
